// TODO: adicionar como padrão uma foto de loading
// TODO: adicionar como padrão uma foto de erro
import { useEffect, useState } from 'react';
import { getUserPhotoURL } from '../database/utils/storage';

export default function useUserPhoto(userID, userPhotoField) {
  const [avatarURL, setAvatarURL] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userID) {
      getUserPhotoURL(userID, userPhotoField)
        .then((avaraURL) => {
          setLoading(false);
          setError(null);
          setAvatarURL(avaraURL);
        })
        .catch((err) => {
          setLoading(false);
          setError(err);
        });
    }
  }, [userID, userPhotoField]);

  return { avatarURL, loading, error };
}
